import ACTIONS from '@/storeActions';
import moment from 'moment-timezone';
import { EventBus, EVENTS } from '@/libs/eventBus';

class BusinessLogicOverview {
  constructor(vue) {
    this.vue = vue;
  }

  async setParticipant(participantId) {
    await this.vue.$store.dispatch(ACTIONS.SET_CURRENT_CANDIDATE, { participantId });
    switch (this.vue.$route.name) {
      case 'participantDocument':
        break;
      default:
        await this.vue.$router.push({ name: 'participantDocument' });
    }
  }

  setParticipantAndExercise(exerciseId, participantId) {
    EventBus.$emit(EVENTS.ASSESSMENT_SAVE);
    this.vue.$store.dispatch(ACTIONS.SET_CURRENT_EXERCISE_AND_CANDIDATE, { exerciseId, participantId });
    if (this.vue.$store.state.currentExerciseDocumentsLoadingState !== 1 || this.vue.$store.state.currentExerciseDocumentsLoadingState !== 2) {
      // replaced by store getter "currentExerciseDocuments" not needed to query the names anymore
      // this.vue.$store.dispatch(ACTIONS.SET_EXERCISE_DOCUMENTS_LOADING_STATE, 1);
      // this.vue.$apiRequest.get(`/exerciseDocuments/exercise/${exerciseId}/documents/names`).then((data) => {
      //   this.vue.$store.dispatch(ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS, data);
      //   this.vue.$store.dispatch(ACTIONS.SET_EXERCISE_DOCUMENTS_LOADING_STATE, 2);
      // })
    }
    const interviewId = this.vue.$store.state.runInfo.exercises.find( (ex) => ex.id === exerciseId)?.interviewId
    this.vue.$store.dispatch(ACTIONS.SET_CURRENT_INTERVIEW, { interviewId })
    if (interviewId) {
      this.vue.$router.push({ name: 'interview' })
      return;
    }

    switch (this.vue.$route.name) {
      case 'assessment':
      case 'observation':
      case 'mixed':
        // do not reroute for these two
        break;
      default:
        // this.vue.$router.push({ name: 'assessment' });
        this.vue.$router.push({ name: 'observation' });
    }
  }

  getRoomAndTime(scheduleEntry) {
    if (!scheduleEntry || !this.vue) return '';
    moment.locale(this.vue.$i18n.locale);
    const parsedTime = moment(scheduleEntry.startTime);
    if (parsedTime.diff(moment(), 'hours') <= -1) return ''
    const formattedTime = parsedTime.fromNow();
    if (scheduleEntry.room === '' || scheduleEntry.room === scheduleEntry.exercise.name) return formattedTime;
    return `${scheduleEntry.room}, ${formattedTime}`;
  }

  checkCompetencyCompletion(assessments, participantId, competencyExerciseMatrix, schedule) {
    let any = false;
    let all = true;
    for (const c of schedule.exercise.competencies) {
      const matrix = competencyExerciseMatrix.find((cem) => cem.exerciseId === schedule.exerciseId && cem.competencyId === c.id);
      const found = assessments()?.find((a) => a.matrixId === matrix.id && a.participantId === participantId && typeof a.selectedValue === 'number') !== undefined;
      any = any || found;
      all = all && found;
    }
    return { all, any }
  }

  getExerciseRatingIcon(schedule, assessments, participantId, competencyExerciseMatrix) {
    if (!assessments) return 'mdi-circle';
    const { all, any } = this.checkCompetencyCompletion(assessments, participantId, competencyExerciseMatrix, schedule);
    if (all) return 'mdi-check-circle';
    if (any) return 'mdi-circle';
    return 'mdi-close-circle';
  }

  getExerciseRatingStatus(schedule, assessments, participantId, competencyExerciseMatrix) {
    if (!assessments) {
      return '';
    }
    const { all, any } = this.checkCompetencyCompletion(assessments, participantId, competencyExerciseMatrix, schedule);

    if (all) return 'green lighten-1';
    if (any) return 'orange lighten-1';
    return 'red lighten-1';
  }

  checkParticipantCompletion(participant, assessments, competencyExerciseMatrix) {
    let any = false;
    let all = true;
    for (const schedule of participant.exercises) {
      for (const c of schedule.exercise.competencies) {
        const matrix = competencyExerciseMatrix.find((cem) => cem.exerciseId === schedule.exerciseId && cem.competencyId === c.id);
        const found = assessments()?.find((a) => a.matrixId === matrix.id && a.participantId === participant.id && typeof a.selectedValue === 'number') !== undefined;
        any = any || found;
        all = all && found;
      }
    }
    return { all, any }
  }

  getParticipantRatingIcon(participant, assessments, competencyExerciseMatrix) {
    if (!assessments) return 'mdi-circle';

    const { all, any } = this.checkParticipantCompletion(participant, assessments, competencyExerciseMatrix)

    if (all) return 'mdi-check-circle';
    if (any) return 'mdi-circle';
    return 'mdi-close-circle';
  }

  getParticipantRatingStatus(participant, assessments, competencyExerciseMatrix) {
    if (!assessments) {
      return '';
    }

    const { all, any } = this.checkParticipantCompletion(participant, assessments, competencyExerciseMatrix)

    if (all) return 'green lighten-1';
    if (any) return 'orange lighten-1';
    return 'red lighten-1';
  }

  getParticipantImage(participantId) {
    const self = this;

    if (!this.vue) {
      return null;
    }
    if (this.vue.$store.state.participantImages[participantId] === 404) {
      return null;
    }
    if (this.vue.$store.state.participantImages[participantId]) {
      return this.vue.$store.state.participantImages[participantId];
    }

    // todo there is currently no endpoint for the candidate images
    this.vue.$apiRequest.getBlob(`/candidates/${participantId}/picture`).then(async (image) => {
      // console.log(image);
      if (!image) {
        self.vue.$store.dispatch(ACTIONS.SET_CANDIDATE_IMAGE, { id: participantId, data: 404 });
        return null;
      }
      // const fileUrl = URL.createObjectURL(image);

      const reader = new FileReader();

      reader.onload = function () {
        const blobBase64 = reader.result;
        // console.log('data url loaded', blobAsDataUrl)
        self.vue.$store.dispatch(ACTIONS.SET_CANDIDATE_IMAGE, { id: participantId, data: blobBase64 });
      };

      reader.readAsDataURL(image);
      return null;
    }).catch((e) => {
      self.vue.$store.dispatch(ACTIONS.SET_CANDIDATE_IMAGE, { id: participantId, data: 404 });
    });

    return null;
  }
}

export default BusinessLogicOverview;
